<button type="button" class="mat-button-close" mat-icon-button (click)="close()" [disabled]="isLoading">
    <i-feather name="X"></i-feather>
</button>

<h2 mat-dialog-title>{{ 'support.request.title' | translate }}</h2>

<mat-dialog-content>
    <p class="subtitle">{{ 'support.request.subtitle' | translate }}</p>

    <form [formGroup]="supportForm" class="support-form">
        <!-- Email Field -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'support.request.email' | translate }}</mat-label>
            <input matInput formControlName="email" type="email" [readonly]="!!user" />
            <mat-icon matPrefix>email</mat-icon>
            @if (supportForm.get('email')?.hasError('required') && supportForm.get('email')?.touched) {
                <mat-error>{{ 'support.request.errors.emailRequired' | translate }}</mat-error>
            }
            @if (supportForm.get('email')?.hasError('email') && supportForm.get('email')?.touched) {
                <mat-error>{{ 'support.request.errors.emailInvalid' | translate }}</mat-error>
            }
        </mat-form-field>

        <!-- Name Field (Optional) -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'support.request.name' | translate }}</mat-label>
            <input matInput formControlName="name" [readonly]="!!user" />
            <mat-icon matPrefix>person</mat-icon>
        </mat-form-field>

        <!-- Subject Field -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'support.request.subject' | translate }}</mat-label>
            <input matInput formControlName="subject" maxlength="100" />
            <mat-icon matPrefix>subject</mat-icon>
            <mat-hint align="end">{{ supportForm.get('subject')?.value?.length || 0 }}/100</mat-hint>
            @if (supportForm.get('subject')?.hasError('required') && supportForm.get('subject')?.touched) {
                <mat-error>{{ 'support.request.errors.subjectRequired' | translate }}</mat-error>
            }
            @if (supportForm.get('subject')?.hasError('maxlength') && supportForm.get('subject')?.touched) {
                <mat-error>{{ 'support.request.errors.subjectMaxLength' | translate }}</mat-error>
            }
        </mat-form-field>

        <!-- Message Field -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'support.request.message' | translate }}</mat-label>
            <textarea matInput formControlName="message" rows="8" maxlength="1000"></textarea>
            <mat-hint align="end">{{ supportForm.get('message')?.value?.length || 0 }}/1000</mat-hint>
            @if (supportForm.get('message')?.hasError('required') && supportForm.get('message')?.touched) {
                <mat-error>{{ 'support.request.errors.messageRequired' | translate }}</mat-error>
            }
            @if (supportForm.get('message')?.hasError('maxlength') && supportForm.get('message')?.touched) {
                <mat-error>{{ 'support.request.errors.messageMaxLength' | translate }}</mat-error>
            }
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isLoading">
        {{ 'shared.cancel' | translate }}
    </button>
    <button mat-flat-button (click)="onSubmit()" [disabled]="isLoading || supportForm.invalid">
        @if (isLoading) {
            <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
        }
        {{ 'support.request.submit' | translate }}
    </button>
</mat-dialog-actions>
